import { render, staticRenderFns } from "./formbuilderReworkSucess.vue?vue&type=template&id=415a994e&scoped=true"
import script from "./formbuilderReworkSucess.vue?vue&type=script&lang=js"
export * from "./formbuilderReworkSucess.vue?vue&type=script&lang=js"
import style0 from "./formbuilderReworkSucess.vue?vue&type=style&index=0&id=415a994e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415a994e",
  null
  
)

export default component.exports